// General
import "./verified-photo-request-element.scss";
// Redux
import { useDispatch } from "react-redux";
import {
  updateNotificationIsSeen,
  updateShowNotificationBadge,

  // Utility Functions
  updateCloseNotificationTabPassthrough,
} from "../../../redux/store/notificationStore";
import {
  updateInterestTab,
  updatePhotoPermissionsTab,
} from "../../../redux/store/interestStore";
// i18next
import { useTranslation } from "react-i18next";
// Components
import CustomAvatar from "../../shared/elements/custom-avatar/custom-avatar";

const VerifiedPhotoRequestElement = (props) => {
  const {
    notificationId,
    id,
    idInt,
    profilePhoto,
    profileDecorations,
    username,
    message,
    timestamp,
    isSeen,
  } = props;

  // Redux variables
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Event Handlers | Button
  const onCheckStatus = () => {
    markAsSeen();
    onCloseNotificationTab();
  };
  const onRedirectToVerifiedPhoto = () => {
    dispatch(updateInterestTab(4));
    dispatch(updatePhotoPermissionsTab(1));
  };

  // Utility Functions
  const returnMessageContent = (messageContent) => {
    const senderUsername = "{{username}}";

    if (messageContent?.includes(senderUsername)) {
      messageContent = messageContent.replace(
        senderUsername,
        `<b>${username}</b>`
      );
    }

    return messageContent;
  };
  const markAsSeen = () => {
    const obj = {
      notificationId,
      isSeen: true,
    };
    dispatch(updateNotificationIsSeen(obj));
    setTimeout(() => {
      dispatch(updateShowNotificationBadge());
    }, 1000);
  };
  const onCloseNotificationTab = () => {
    dispatch(updateCloseNotificationTabPassthrough());
  };

  return (
    <div
      id="notification-verified-photo-request-element-subcomponent"
      className={isSeen ? "" : "notification-unseen"}
      onClick={onCheckStatus}
    >
      <div className="avatar-container">
        <CustomAvatar
          className="profile-photo"
          src={profilePhoto}
          profileBorder={profileDecorations?.profile_border_url}
        />
      </div>

      <div className="verified-photo-request-body-container">
        <span
          dangerouslySetInnerHTML={{
            __html: returnMessageContent(message),
          }}
        />{" "}
        <span className="timestamp">{timestamp}</span>
        {false && <span className="red-dot"></span>}
      </div>

      <div className="button-container">
        <div className="watch-now-button" onClick={onRedirectToVerifiedPhoto}>
          {t("common.check")}
        </div>
      </div>
    </div>
  );
};

export default VerifiedPhotoRequestElement;
